module.exports = __webpack_public_path__ + "img/2ndOnLandingPage.49732bc7.jpeg";